/**
 * File extensions the CODE V importer accepts.
 *
 * Zero-import on purpose, like `converters/zemaxContainer.ts`'s
 * `ZEMAX_IMPORT_EXTENSIONS`: the frontend imports this from `dist/` to build
 * its upload accept-list, so it must not pull in `fs` or any parser code.
 *
 * `.len` (CODE V's binary lens save) is deliberately absent — it has no
 * published format. A `.len` lens is exported from CODE V as `.seq` with `WRL`.
 */
export const CODEV_IMPORT_EXTENSIONS = ['.seq'] as const;
export type CodevImportExtension = (typeof CODEV_IMPORT_EXTENSIONS)[number];
